import { ReturnStatusZod } from "@redotech/redo-return-core-common/return-status-zod";
import * as z from "zod";
import { defineIntegrationSettings } from "../define-settings";

const URL_LIKE_PATTERN = /[:/.]/;

export const apparelMagicSettings = defineIntegrationSettings({
  fields: {
    companyId: z
      .string()
      .trim()
      .min(1, "Company ID is required")
      .refine((value) => !URL_LIKE_PATTERN.test(value), {
        message:
          "Company ID should be just the subdomain, not a full URL. For example, enter 'yourstore' instead of 'yourstore.app.apparelmagic.com'.",
      }),
    creditMemoEnabled: z.boolean(),
    creditMemoRestock: z.boolean(),
    creditMemoTriggerStatus: ReturnStatusZod,
    miscChargesEnabled: z.boolean(),
    miscChargesGlAcct: z.string().trim().min(1, "GL account is required"),
  },
  secrets: { apiKey: z.string().trim().min(1, "API key is required") },
  connectOnly: {},
  computed: {},
});
